import Impressao from './Impressao';

export default Impressao;